import ReactGA from 'react-ga4';

// Initialize GA4 with your measurement ID from environment variable
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  
  if (process.env.NODE_ENV === 'production' && measurementId) {
    ReactGA.initialize(measurementId);
    console.log('GA4 initialized with ID:', measurementId);
  } else if (process.env.NODE_ENV !== 'production') {
    console.log('GA4 not initialized in development mode');
  } else {
    console.warn('GA4 measurement ID not found in environment variables');
  }
};

// Track page views
export const trackPageView = (path) => {
  if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.send({ hitType: 'pageview', page: path });
    console.log(`Page view tracked: ${path}`);
  }
};

// Track custom events
export const trackEvent = (category, action, label, value) => {
  if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
    console.log(`Event tracked: ${category} - ${action} - ${label}`);
  }
}; 